var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9571 14.6036C18.5666 14.9941 17.9334 14.9941 17.5429 14.6036L12.25 9.31066L6.95711 14.6036C6.56658 14.9941 5.93342 14.9941 5.54289 14.6036C5.15237 14.213 5.15237 13.5799 5.54289 13.1893L11.3661 7.36612C11.8543 6.87796 12.6457 6.87796 13.1339 7.36612L18.9571 13.1893C19.3476 13.5799 19.3476 14.213 18.9571 14.6036Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.f40963a9c09ce586c2a7ce19c62e2a4a.svg";
export { ForwardRef as ReactComponent };